<template>
  <div>
    <div v-show="items.length > 0" class="msu-map-legend">
      <span><i class="msu-map-legend__published"></i>{{ $t('Опубликовано') }}</span>
      <span><i class="msu-map-legend__discussion"></i>{{ $t('На обсуждении') }}</span>
    </div>
    <div ref="map" class="msu-map" :aria-label="$t('Карта органов МСУ')"></div>
    <v-alert v-if="items.length === 0" type="info" outlined class="mt-4">
      {{ $t('Для выбранных органов координаты пока не заполнены') }}
    </v-alert>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    map: null,
    markers: []
  }),
  watch: {
    items() {
      this.renderMarkers()
    }
  },
  mounted() {
    this.map = L.map(this.$refs.map).setView([41.2, 74.7], 7)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 18
    }).addTo(this.map)
    this.renderMarkers()
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove()
    }
  },
  methods: {
    renderMarkers() {
      if (!this.map) return
      this.markers.forEach(marker => marker.remove())
      this.markers = this.groupItemsByTerritory().map(item => {
        const projectCount = Number(item.projectCount) || 0
        const discussionProjectCount = Number(item.discussionProjectCount) || 0
        const tooltip = document.createElement('div')
        const title = document.createElement('strong')
        title.textContent = item.name
        tooltip.appendChild(title)
        tooltip.appendChild(document.createElement('br'))
        tooltip.appendChild(document.createTextNode(`${this.$t('Опубликовано')}: ${projectCount}`))
        tooltip.appendChild(document.createElement('br'))
        tooltip.appendChild(document.createTextNode(`${this.$t('На обсуждении')}: ${discussionProjectCount}`))

        const marker = L.marker([item.latitude, item.longitude], {
          icon: L.divIcon({
            className: 'msu-count-marker',
            html: `<span class="msu-count-marker__published">${projectCount}</span><span class="msu-count-marker__discussion">${discussionProjectCount}</span>`,
            iconSize: [44, 44],
            iconAnchor: [22, 22]
          }),
          title: item.name,
          alt: item.name
        })
          .addTo(this.map)
          .bindTooltip(tooltip)
        marker.on('click', () => {
          this.$router.push(this.$i18nRoute({ name: 'msu-authority', params: { id: item.id } }))
        })
        return marker
      })
      if (this.markers.length > 0) {
        this.map.fitBounds(L.featureGroup(this.markers).getBounds().pad(0.15), { maxZoom: 12 })
      }
    },
    groupItemsByTerritory() {
      const groups = {}
      this.items.forEach(item => {
        const key = item.soateCode || `${item.latitude}:${item.longitude}`
        const projectCount = Number(item.projectCount) || 0
        const discussionProjectCount = Number(item.discussionProjectCount) || 0
        if (!groups[key]) {
          groups[key] = {
            ...item,
            projectCount,
            discussionProjectCount,
            primaryProjectCount: projectCount
          }
          return
        }

        groups[key].projectCount += projectCount
        groups[key].discussionProjectCount += discussionProjectCount
        if (projectCount > groups[key].primaryProjectCount) {
          groups[key].id = item.id
          groups[key].name = item.name
          groups[key].primaryProjectCount = projectCount
        }
      })

      return Object.values(groups)
    }
  }
}
</script>

<style scoped>
.msu-map {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 520px;
  border: 1px solid #e1e1e1;
  z-index: 1;
}
.msu-map-legend { display: flex; flex-wrap: wrap; gap: 18px; margin-bottom: 10px; color: #49525d; }
.msu-map-legend span { display: inline-flex; align-items: center; gap: 7px; }
.msu-map-legend i { display: inline-block; width: 14px; height: 14px; border-radius: 50%; }
.msu-map-legend__published { background: #1976d2; }
.msu-map-legend__discussion { background: #2e7d32; }
</style>

<style>
.msu-count-marker { background: transparent !important; border: 0 !important; }
.msu-count-marker__published {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: #fff;
  background: #1976d2;
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  font-size: 15px;
  font-weight: 700;
}
.msu-count-marker__discussion {
  position: absolute;
  right: -7px;
  bottom: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 5px;
  color: #fff;
  background: #2e7d32;
  border: 2px solid #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  font-size: 11px;
  font-weight: 700;
}
</style>
